import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

/* Local components */
import { AuthComponent } from './auth.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';

/* Routes */
import { AuthRoutingModule } from './auth-routing.module';

import { ThemeModule } from 'src/app/@theme/theme.module';
import { LocalStorage } from 'src/app/core/localstorage';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { RequestPasswordComponent } from './components/request-password/request-password.component';
import { ValidateComponent } from './components/validate/validate.component';

import { UserFoundComponent } from './components/user-found/user-found.component';
import { OAuthComponent } from './components/o-auth/o-auth.component';
import { RequestAccountRecoverComponent } from './components/request-account-recover/account-recover.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
@NgModule({
    declarations: [
        LoginComponent,
        RegisterComponent,
        AuthComponent,
        RequestPasswordComponent,
        ChangePasswordComponent,
        ValidateComponent,
        UserFoundComponent,
        OAuthComponent,
        RequestAccountRecoverComponent,
    ],
    imports: [CommonModule, AuthRoutingModule, ThemeModule, DragDropModule],
    providers: [LocalStorage],
})
export class AuthModule {}
